// 運営がかけた機能の制限（管理画面から）。手元の userConfig で判定し、押した時点で理由を出す
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { RootState } from "app/store";
import { USER_RESTRICTED_CODE, UserRestriction, UserRestrictionFeature } from "app/types";
import I18n from "common/i18n";

// 公開 API が「運営が止めている」で断ったか（thunk の rejectWithValue の中身）
export const isUserRestrictedError = (error: unknown) =>
  (error as { code?: string } | null)?.code === USER_RESTRICTED_CODE;

// いま効いている制限（期限切れは無視）。無ければ null
export const useUserRestriction = (feature: UserRestrictionFeature): UserRestriction | null => {
  const restrictions = useSelector((state: RootState) => state.config.userConfig.restrictions);
  return (
    restrictions?.find(
      (r) => r.feature === feature && (!r.expires_at || dayjs(r.expires_at).isAfter(dayjs())),
    ) ?? null
  );
};

// 「いつまで」の言い方。無期限は「しばらくの あいだ」
export const restrictionUntilText = (restriction: UserRestriction | null) =>
  restriction?.expires_at
    ? I18n.t("MSG_USER_RESTRICTION_UNTIL", {
        date: dayjs(restriction.expires_at).format("YYYY/MM/DD HH:mm"),
      })
    : I18n.t("MSG_USER_RESTRICTION_UNTIL_NONE");
